import { useState } from 'react';
import {
  AppModal,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import { UnmountClosed } from 'react-collapse/lib/UnmountClosed';
import { Formik } from 'formik';
import { ProgressBar } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import AuxSidebar from '../../../../Sidebar/AuxSidebar';
import colors from '../../../../../constants/colors';
import { axiosPath } from '../../../../../routing/helpers/router';
import Translator from '../../../../components/helpers/Translator';
import minions from '../../../../../minions/minions';
import errorHandler from '@/layout/components/error/ErrorHandler';
import ResponsibleSelect from '@/layout/components/form/Selects/ResponsibleSelect';
import useIsMounted from '../../../../components/hooks/useIsMounted';

const BlockChangeSidebarBlock = () => {
  const { moduleBridgeHex, filtersHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened
  );
  const resourcesCheckbox = useSelector(
    (state) => state.currentPage?.options?.resourcesCheckbox,
  );
  const checkedResourcesBlockChange = useSelector(
    (state) => state.currentPage?.checkedResourcesBlockChange,
  );
  const totalItemsCount = useSelector(
    (state) => state.currentPage?.pagination?.totalCount
  );
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.permissions
  );
  const view = useSelector((state) => state.currentPage?.view);
  const [responsibleSection, setResponsibleSection] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [blockChangePercent, setBlockChangePercent] = useState();

  const handleAuxSidebar = () => {
    if (auxSidebar !== 'blockChange')
      dispatch(
        currentPageAction.change('auxSidebar', { opened: 'blockChange' })
      );
    else dispatch(currentPageAction.change('auxSidebar', { opened: null }));
  };

  const handleCheckResources = (value) => {
    dispatch(currentPageAction.change('options', { resourcesCheckbox: value }));
  };

  const handleBlockChange = async (values, isNew = true) => {
    await axios
      .post(
        axiosPath('api_r_user_module_resourceManager_blockChange'),
        minions.forms.toFormData({
          ...values,
          moduleBridgeHex,
          view,
          isNew,
          checkedElementIDs: resourcesCheckbox
            ? checkedResourcesBlockChange || []
            : [],
          filtersHex,
        }),
        { headers: { 'Content-Type': 'multipart/form-data' } },
      )
      .then((res) => {
        if (isMounted.current)
          setBlockChangePercent(res.data.percent);
        
        if (res.data.isFinished) window.location.reload();
        else {
          setShowConfirmModal(false);
          handleBlockChange(values, false);
        }
      })
      .catch((err) => {
        if (err.response.status === 423) {
          alert(err.response.data);
          setShowConfirmModal(false);
        }
        dispatch(errorHandler(err));
      });
  };

  return (
    <>
      <li
        className={auxSidebar && auxSidebar === 'blockChange' ? 'active' : ''}
        onClick={() => handleAuxSidebar()}
      >
        <span className="sidebar-element">
          <AppRemixIcon icon="stack" />{' '}
          <span className="sb-title">
            <Translator file="module-legalCompliance" name="block.actions" />
          </span>
        </span>
      </li>
      <AuxSidebar
        title={
          <Translator file="module-legalCompliance" name="block.actions" />
        }
        isOpen={auxSidebar && auxSidebar === 'blockChange'}
        width="350px"
        position="right"
        onClose={() => handleAuxSidebar()}
      >
        {auxSidebar && auxSidebar === 'blockChange' && (
          <Formik
            initialValues={{
              addResponsibleIDs: [],
              removeResponsibleIDs: [],
            }}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={(values) => handleBlockChange(values, true)}
          >
            {({ handleSubmit, values, setFieldValue, errors }) => (
              <div className="row">
                <div className="col-lg-12">
                  <p
                    className="text-justify pl-2 pr-2"
                    style={{ fontSize: '12px' }}
                  >
                    <Translator
                      file="module-resourceManager"
                      name="m.resource.block-actions-text"
                    />
                  </p>
                  <p
                    className="text-justify pl-2 pr-2 mt-2 mb-4"
                    style={{ fontSize: '12px' }}
                  >
                    <Translator
                      file="module-resourceManager"
                      name="m.resource.block-actions-text-2"
                      isHtml
                    />
                  </p>
                  {permissions?.resourceManager?.blockChange?.responsibles && (
                    <>
                      <BlockSection
                        onClick={() =>
                          setResponsibleSection(!responsibleSection)
                        }
                      >
                        <AppRemixIcon
                          icon={
                            responsibleSection
                              ? 'arrow-down-s'
                              : 'arrow-right-s'
                          }
                          filled
                        />
                        <Translator
                          file="module-legalCompliance"
                          name="actions.of.responsible"
                        />
                      </BlockSection>
                      <UnmountClosed isOpened={responsibleSection}>
                        <ResponsibleSelect
                          title={
                            <Translator
                              file="module-resourceManager"
                              name="m.resource.add-responsible"
                            />
                          }
                          value={values.addResponsibleIDs}
                          onHandleChange={(opt) =>
                            setFieldValue('addResponsibleIDs', opt)
                          }
                          apiCall="api_r_user_module_resourceManager_responsible_list"
                          hasSearchBox
                          isClearable
                        />
                        <ResponsibleSelect
                          title={
                            <Translator
                              file="module-resourceManager"
                              name="m.resource.remove-responsible"
                            />
                          }
                          value={values.removeResponsibleIDs}
                          onHandleChange={(opt) =>
                            setFieldValue('removeResponsibleIDs', opt)
                          }
                          apiCall="api_r_user_module_resourceManager_responsible_list"
                          hasSearchBox
                          isClearable
                        />
                      </UnmountClosed>
                    </>
                  )}

                  <SelectList className="mt-4">
                    <li onClick={() => handleCheckResources(true)}>
                      <AppRemixIcon
                        icon={
                          resourcesCheckbox
                            ? 'record-circle'
                            : 'checkbox-blank-circle'
                        }
                        className="mr-2"
                        size={14}
                      />
                      <Translator
                        file="module-resourceManager"
                        name="m.resource.resources.select"
                      />
                    </li>
                    <li onClick={() => handleCheckResources(false)}>
                      <AppRemixIcon
                        icon={
                          !resourcesCheckbox
                            ? 'record-circle'
                            : 'checkbox-blank-circle'
                        }
                        className="mr-2"
                        size={14}
                      />
                      <Translator
                        file="module-legalCompliance"
                        name="apply.to.all"
                      />
                      <small className="ml-1">
                        (
                        <Translator
                          file="module-legalCompliance"
                          name="only.filtered"
                        />
                        )
                      </small>
                    </li>
                  </SelectList>
                  {(resourcesCheckbox &&
                    (!checkedResourcesBlockChange ||
                      checkedResourcesBlockChange.length === 0)) ||
                  ((!values.addResponsibleIDs ||
                    values.addResponsibleIDs.length === 0) &&
                    (!values.removeResponsibleIDs ||
                      values.removeResponsibleIDs.length === 0)) ? (
                    <span
                      className="btn btn-block btn-primary disabled mt-3"
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-legalCompliance"
                          name="select.at.least.an.obligation"
                        />,
                      )}
                    >
                      <Translator
                        file="module-legalCompliance"
                        name="module.lc.blockChange.apply"
                      />
                    </span>
                  ) : (
                    <span
                      className="btn btn-block btn-primary mt-3"
                      onClick={() => setShowConfirmModal(true)}
                    >
                      <Translator
                        file="module-legalCompliance"
                        name="module.lc.blockChange.apply"
                      />
                    </span>
                  )}
                </div>
                <AppModal
                  show={showConfirmModal}
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="apply.block.actions"
                    />,
                  )}
                  onClose={() => setShowConfirmModal(false)}
                  onConfirm={handleSubmit}
                  isConfirmBtn
                  isCancelBtn
                  confirmBtnText={ReactDOMServer.renderToString(
                    <Translator file="user" name="user.confirm" />,
                  )}
                  cancelBtnText={ReactDOMServer.renderToString(
                    <Translator file="user" name="user.cancel" />,
                  )}
                  size="lg"
                >
                  <p>
                    <Translator
                      file="module-legalCompliance"
                      name="confirm.apply.changes"
                    />
                  </p>
                  <p>
                    <Translator
                      file="module-legalCompliance"
                      name="change.apply.to.no.reversible"
                      variables={{
                        total: resourcesCheckbox
                          ? checkedResourcesBlockChange?.length || 0
                          : totalItemsCount,
                      }}
                      isHtml
                    />
                  </p>
                </AppModal>
                <AppModal
                  show={!!blockChangePercent}
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="doing.block.action"
                    />,
                  )}
                >
                  <Translator
                    file="module-legalCompliance"
                    name="doing.block.action.please.no.close"
                  />
                  <ProgressBar
                    now={blockChangePercent}
                    label={`${blockChangePercent}%`}
                    animated
                  />
                </AppModal>
              </div>
            )}
          </Formik>
        )}
      </AuxSidebar>
    </>
  );
};
export default BlockChangeSidebarBlock;

const SelectList = styled.ul`
  list-style: none;
  li {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

const BlockSection = styled.div`
  color: ${colors.primary};
  font-size: 14px;
  margin-top: 10px;
  cursor: pointer;
`;
